import { FlaskConical, Headphones, TerminalSquare } from 'lucide-react'
import { labItems, stackGroups } from '@/data/siteContent'
import { SectionShell } from '@/components/layout/SectionShell'

const icons = {
  headphones: Headphones,
  terminal: TerminalSquare,
  flask: FlaskConical,
}

export function LabSection() {
  return (
    <SectionShell
      id="lab"
      labelledBy="lab-heading"
      className="page-snap-section flex flex-col justify-center py-16 sm:py-20"
    >
      <div className="reveal rounded-2xl bg-surface-container-low/45 px-5 py-16 sm:px-8 lg:px-8 lg:py-32">
        <div className="grid gap-16 lg:grid-cols-[0.95fr_1fr] lg:gap-20">
          <div className="space-y-12">
            <div className="space-y-5">
              <p className="section-label">.Env</p>
              <h2 id="lab-heading" className="font-display text-4xl font-medium tracking-[-0.03em] sm:text-3xl">
                Environment
              </h2>
            </div>
            <div className="glass-panel space-y-7 rounded-lg border border-border p-6 sm:p-8">
              {labItems.map((item) => {
                const Icon = icons[item.icon]
                return (
                  <div key={item.label} className="flex gap-5">
                    <Icon className="mt-1 h-5 w-5 flex-none text-primary" aria-hidden="true" />
                    <div>
                      <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted/85">{item.label}</p>
                      <p className="mt-1 text-base font-medium text-foreground sm:text-md">{item.value}</p>
                    </div>
                  </div>
                )
              })}
              <div className="border-t border-border pt-6">
                <div className="h-2 overflow-hidden rounded-sm bg-surface-container-high">
                  <div className="relative h-full w-3/4 overflow-hidden bg-primary">
                    <span className="absolute inset-y-0 left-0 w-1/3 -translate-x-full animate-shimmer bg-white/35" />
                  </div>
                </div>
                <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.18em] text-muted/75">CPU LOAD: OPTIMIZED</p>
              </div>
            </div>
          </div>

          <div className="space-y-12">
            <div className="space-y-5">
              <p className="section-label">.dev</p>
              <h2 className="font-display text-4xl font-medium tracking-[-0.03em] sm:text-3xl">Development</h2>
            </div>
            <div className="space-y-10">
              {stackGroups.map((group) => (
                <div key={group.label}>
                  <h3 className="mb-4 font-mono text-[11px] uppercase tracking-[0.28em] text-muted/80">{group.label}</h3>
                  <div className="flex flex-wrap gap-2">
                    {group.items.map((item) => (
                      <span key={item} className="terminal-tag">[ {item} ]</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SectionShell>
  )
}
